'use strict';

angular.module('uniromaLandingApp').controller('EsterniDetailController',
		['$scope', '$rootScope', '$stateParams', 'entity', 'userId','Esterni',function ($scope, $rootScope, $stateParams, entity, userId, Esterni) {
        $scope.esterni = entity;
        $scope.userId = userId;

        
        $scope.load = function (id) {
            Esterni.get({id: id}, function(result) {
                $scope.esterni = result;
            });
        };
        $rootScope.$on('uniromaLandingApp:esterniUpdate', function(event, result) {
            $scope.esterni = result;
        });
    }]);
